export function useCostOfKitForm() {
  const isOpen = useState('isOpenCostOfKitForm', () => false);
  const title = useState('CostOfKitFormTitle', (): string => '');

  function open(formTitle: string) {
    title.value = formTitle;
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
  }

  return { isOpen, open, close, title };
}
